import React, {useEffect} from 'react';

const InfoInput = ({
	children,
	error,
	success,
}) => {

	return (
		<label
			className={`com-radio${error ? ' state--error' : ''}${
				success ? ' state--success' : ''
			}`}>
			<span>{children}</span>
		</label>
	);
};

export default InfoInput;
